import { useEffect, useState } from "react";
import { numberFormatter } from "../utils/utils";

const withPercentageBlock = (Component: React.ComponentType<any>) => {
  return ({ xPerformance, ...props }: { xPerformance: number }) => {
    const THRESHOLD = 0.01;

    const [averageToFormat, setAverageToFormat] = useState(
      xPerformance >= 1 + THRESHOLD || xPerformance <= 1 - THRESHOLD ? xPerformance : 1,
    );
    const [value, setValue] = useState(
      numberFormatter.format(+Math.abs(averageToFormat).toFixed(2)) == "0"
        ? "0.00"
        : (+numberFormatter.format(+Math.abs(averageToFormat).toFixed(2))).toFixed(2),
    );
    const [arrowDirection, setArrowDirection] = useState(
      averageToFormat !== 0 ? (xPerformance < 0 ? "down" : "up") : "none",
    );

    useEffect(() => {
      const averageToFormat =
        xPerformance >= 1 + THRESHOLD || xPerformance <= 1 - THRESHOLD ? xPerformance : 1;
      const unFixedValue = numberFormatter.format(+Math.abs(averageToFormat).toFixed(2));
      setAverageToFormat(averageToFormat);
      setValue(unFixedValue == "0" ? "0.00" : (+unFixedValue).toFixed(2));
      setArrowDirection(averageToFormat !== 0 ? (xPerformance < 0 ? "down" : "up") : "none");
    }, [xPerformance]);

    return (
      <Component
        averageToFormat={averageToFormat}
        value={value}
        arrowDirection={arrowDirection}
        {...props}
      />
    );
  };
};

export default withPercentageBlock;
